import { DateTime } from "luxon"
import { SupportedLanguage } from "../business/enum/SupportedLanguage"

export const toLocalDate = (date: string, lang: SupportedLanguage) =>
  DateTime.fromISO(date).setLocale(lang).toLocaleString(DateTime.DATE_FULL)
